
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import html2canvas from 'html2canvas'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {}
})
export default class StudentCardPop extends Vue {
  visible: boolean = false
  qrcodeUrl: string = ''
  loadingQrcode: boolean = false
  loadingAvatar: boolean = true

  imgSrc: string = ''
  filename: string = '学生证'
  loading: boolean = false

  @Ref()
  imgDom: HTMLDivElement

  get ShowStore() {
    return this.$store.$storeShow
  }

  get UserStore() {
    return this.$store.$storeUser
  }

  get PageStore() {
    return this.$store.$myV2.Classroom
  }

  get defaultImgUrl() {
    return this.getHeaderImgUrl('')
  }

  get avatarUrl() {
    return this.getHeaderImgUrl(this.UserStore.UserInfo.id)
  }

  loadDefaultAvatar() {
    return new Promise((resolve, reject) => {
      const img = new Image()
      img.crossOrigin = 'anonymous'
      img.src = this.defaultImgUrl
      img.onload = resolve
      img.onerror = reject
    })
  }

  onSave() {
    let a = document.createElement('a') // 生成一个a元素
    let event = new MouseEvent('click') // 创建一个单击事件
    a.download = this.filename + '.jpeg' // 设置图片名称
    a.href = this.imgSrc // 将生成的URL设置为a.href属性
    a.dispatchEvent(event) // 触发a的单击事件
  }

  getImgUrl(shareContent: HTMLDivElement, opts) {
    return new Promise((resolve, reject) => {
      html2canvas(shareContent, opts)
        .then(canvas => {
          let context = canvas.getContext('2d')
          // 【重要】关闭抗锯齿
          // context.mozImageSmoothingEnabled = false;
          // context.webkitImageSmoothingEnabled = false;
          // context.msImageSmoothingEnabled = false;
          context!.imageSmoothingEnabled = false

          // 【重要】默认转化的格式为png,也可设置为其他格式
          const url = canvas.toDataURL('image/jpeg')
          console.log('生成图片成功')
          resolve(url)
        })
        .catch(error => {
          console.log('生成图片失败')
          console.error('html2canvas something went wrong!', error)
          reject(error)
        })
    })
  }

  handleShared() {
    if (this.loading) return

    this.loading = true

    // 获取dom，确认dom存在然后生成，生成过程中给一个加载效果
    this.$nextTick(async () => {
      let shareContent = this.imgDom //需要截图的包裹的（原生的）DOM 对象

      if (!shareContent) return

      let width = shareContent.offsetWidth //获取dom 宽度
      let height = shareContent.offsetHeight //获取dom 高度
      let scale = window.devicePixelRatio || 1 //定义任意放大倍数 支持小数

      const canvas = document.createElement('canvas') //创建一个canvas节点
      canvas.width = width * scale //定义canvas 宽度 * 缩放
      canvas.height = height * scale //定义canvas高度 *缩放
      canvas.style.width = width + 'px'
      canvas.style.height = height + 'px'

      let opts = {
        scale, // 添加的scale 参数
        canvas: canvas, // 自定义 canvas
        logging: true, // 日志开关，便于查看html2canvas的内部执行流程
        width: width, // dom 原始宽度
        height: height,
        useCORS: true, //【重要】开启跨域配置
        backgroundColor: null
      }

      try {
        const res = (await this.getImgUrl(shareContent, opts)) as string
        this.imgSrc = res
        // 执行下载操作
        this.onSave()
      } catch (error) {
        this.$message.error('生成图片失败')
      } finally {
        this.loading = false
      }
    })
  }

  async getAppletsQrcode(memberId: number) {
    try {
      this.loadingQrcode = true
      const url = await this.ShowStore.getQrcodeUrl({
        page: 'pages/my/center/index',
        query: `memberId=${memberId}`,
        appletsType: 2,
        hyaline: true
      })

      this.qrcodeUrl = url
    } catch (error) {
      console.log('loading-qrcode-fail', error)
    } finally {
      this.loadingQrcode = false
    }
  }

  getHeaderImgUrl(id: string | number) {
    const idStr = id.toString()
    const url = new URL(this.$store.$global.fileTarget + this.stringToHex(idStr) + '.jpg')

    if (this.$store.$global.upUpdateTime && this.$store.$storeUser.isLogin() && idStr == this.$store.$storeUser.UserInfo.id) {
      url.searchParams.set('avatar', `${this.$store.$global.upUpdateTime}`)
    }

    url.searchParams.set('t', `${Date.now()}`)

    return url.toString()
  }

  open() {
    this.visible = true
  }

  close() {
    this.visible = false
  }

  @Watch('visible')
  onVisibleChange(val: boolean) {
    if (!val || this.qrcodeUrl !== '') return

    this.getAppletsQrcode(this.UserStore.UserInfo.id)
  }

  @Emit('closed')
  onClosed() {}

  created(): void {
    // 预加载默认头像图片
    this.loadDefaultAvatar()
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
